import baseService from '../shared/baseService';

const clientClipperFiltersService = (clientClipperId: number) =>
    baseService(`client-clippers/${clientClipperId}/filters`);

export default { 
    clientClipperFiltersService
};

